export interface Wilaya {
  code: string;
  price: number;
  name: string;
}

const wilayas: Wilaya[] = [
  { code: "1", price: 2300, name: "Adrar" },
  { code: "2", price: 850, name: "Chlef" },
  { code: "3", price: 950, name: "Laghouat" },
  { code: "4", price: 850, name: "Oum El Bouaghi" },
  { code: "5", price: 850, name: "Batna" },
  { code: "6", price: 850, name: "Béjaïa" },
  { code: "7", price: 950, name: "Biskra" },
  { code: "8", price: 2300, name: "Béchar" },
  { code: "9", price: 770, name: "Blida" },
  { code: "10", price: 850, name: "Bouira" },
  { code: "12", price: 950, name: "Tébessa" },
  { code: "13", price: 850, name: "Tlemcen" },
  { code: "14", price: 850, name: "Tiaret" },
  { code: "15", price: 850, name: "Tizi Ouzou" },
  { code: "16", price: 770, name: "Alger" },
  { code: "17", price: 950, name: "Djelfa" },
  { code: "18", price: 850, name: "Jijel" },
  { code: "19", price: 850, name: "Sétif" },
  { code: "20", price: 850, name: "Saïda" },
  { code: "21", price: 850, name: "Skikda" },
  { code: "22", price: 850, name: "Sidi Bel Abbès" },
  { code: "23", price: 850, name: "Annaba" },
  { code: "24", price: 850, name: "Guelma" },
  { code: "25", price: 850, name: "Constantine" },
  { code: "26", price: 850, name: "Médéa" },
  { code: "27", price: 850, name: "Mostaganem" },
  { code: "28", price: 850, name: "M'Sila" },
  { code: "29", price: 850, name: "Mascara" },
  { code: "30", price: 950, name: "Ouargla" },
  { code: "31", price: 100, name: "Oran" },
  { code: "34", price: 850, name: "Bordj Bou Arreridj" },
  { code: "35", price: 770, name: "Boumerdès" },
  { code: "36", price: 850, name: "El Tarf" },
  { code: "38", price: 850, name: "Tissemsilt" },
  { code: "39", price: 950, name: "El Oued" },
  { code: "40", price: 850, name: "Khenchela" },
  { code: "41", price: 850, name: "Souk Ahras" },
  { code: "42", price: 850, name: "Tipaza" },
  { code: "43", price: 850, name: "Mila" },
  { code: "44", price: 850, name: "Aïn Defla" },
  { code: "45", price: 2300, name: "Naâma" },
  { code: "46", price: 850, name: "Aïn Témouchent" },
  { code: "47", price: 950, name: "Ghardaïa" },
  { code: "48", price: 850, name: "Relizane" },
];

export const getShippingPrice = (wilaya: string = "16"): number => {
  const found = wilayas.find((wil) => wilaya === wil.code);
  return found?.price ?? 770; // Default to Alger price
};

export default wilayas;
